import AccessControlEvents from '../components/templates';

export const AccessControlEventsContainer = () => {
  return <AccessControlEvents />;
};
